const config = {
  API_URL: process.env.REACT_APP_API_URL || 'https://instapres.com/api', // override for local dev
  SITE_URL: 'https://instapres.com',
  IS_DEV: process.env.NODE_ENV === 'development',

  PLAY_STORE_LINK: 'https://play.google.com/store/apps/details?id=mobile.ba.pres',
  APP_STORE_LINK: 'https://apps.apple.com/app/instapres/id6737146239',
  // One smart link for the QR code, the mobile-web "Otvori" bar and every
  // "Preuzmi" link (spec part 8). The server sends it to the right store.
  APP_LINK: 'https://instapres.com/app',
  // "Otvori" on mobile web (Components/AppBar.js). On www: iOS opens an
  // installed app only for links to a different host than the page's own.
  OPEN_IN_APP_LINK: 'https://www.instapres.com/app',
  ANDROID_PACKAGE: 'mobile.ba.pres',
  APP_SCHEME: 'presmobile', // the app's own URL scheme, in every version
  CONTACT_EMAIL: 'info@instapres.com',

  // AdSense (ads spec, web). Whether ads show, where, and the slot ids come
  // from GET /v1/config (Utils/ads.js); only the publisher id lives here.
  ADS: {
    CLIENT: 'ca-pub-1423089575668905',
  },

  // Analytics (analytics spec 2): PostHog only. The key isn't a secret.
  // POSTHOG_HOST becomes 'https://e.instapres.com' (our PostHog proxy) once
  // its DNS works; until then PostHog's own EU host. UI host: PostHog's app,
  // for links PostHog builds (toolbar), whichever the API host is.
  POSTHOG_KEY: 'phc_pzi8RNAHdbyTkjcWyQpSXEd4WmQuaUd4Q7jf8VJ3iKH2',
  POSTHOG_HOST: 'https://eu.i.posthog.com',
  POSTHOG_UI_HOST: 'https://eu.posthog.com',
}

export default config
